import { observer } from 'mobx-react-lite';
import React from 'react';
import * as styles from '../Filter/Filter.scss';
import FilterIcon from '../FilterIcon';
import strings from '../../strings';

const AutoparkIcon = ({ autopark, handleAutoparkClick }) => {
  const realTruckImgUrlDefault = '/rating/assets/images/real-truck.svg';
  const realTruckImgUrlSelected = '/rating/assets/images/real-truck-selected.svg';

  const autoparkIcon = (
    <img
      alt="real-truck"
      className={styles.realTruck}
      src={realTruckImgUrlDefault}
    />
  );

  const autoparkIconSelected = (
    <img
      alt="real-truck-selected"
      className={styles.realTruck}
      src={realTruckImgUrlSelected}
    />
  );

  const autoparkText = strings.autopark;

  return (
    <FilterIcon
      icon={autoparkIcon}
      iconSelected={autoparkIconSelected}
      text={autoparkText}
      pressed={autopark}
      handleClick={handleAutoparkClick}
    />
  );
};

export default observer(AutoparkIcon);
